import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiUrl } from "../../config/config";
import { Toaster, toast } from "react-hot-toast";
import TopNav from "../common/TopNav";
import SideBar from "../common/SideBar";
import DeviceHistoryModal from "./DeviceHistoryModal";
import "./devicedeatils.css";

const inputStyle = {
  width: "100%", padding: "9px 12px", background: "#0a1f20",
  border: "1px solid #1a5a62", borderRadius: 7, color: "#c8dde0",
  fontSize: "13px", outline: "none", boxSizing: "border-box",
};
const labelStyle = {
  display: "block", color: "#89a8c0", fontSize: "11px", fontWeight: 600,
  textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6,
};

const DeviceDetailsDistributor = () => {
  const defaultVerifierName = localStorage.getItem("verifiername") || "";
  const [devices, setDevices] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 20;
  const [menus] = useState([
    { title: "Patient List", url: "/Partner" },
    { title: "Device Details", url: "/device-home" },
  ]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  // Device clicked in the SERIAL NO column — opens the shared history popup
  // listing the patients this device has previously been connected to.
  const [historyDevice, setHistoryDevice] = useState(null);
  const [newDevice, setNewDevice] = useState({
    serial_no: "", mac_id: "", whatsapp: "", mail: "",
    customer_details: defaultVerifierName, contactPerson: "", VerisonDetails: "",
  });

  const [selfKeys, setSelfKeys] = useState([]);

  useEffect(() => { fetchDevices(); fetchSelfIdentity(); }, []);

  const fetchDevices = async () => {
    try {
      const response = await axios.get(`${apiUrl}api/users/GetDevicedetails`);
      setDevices(response.data.reverse());
    } catch (error) {
      console.error("Error fetching device details", error);
    }
  };

  // Resolve this partner's own WCN code + display name from the customer
  // list. The login payload on some servers doesn't include customerId,
  // so localStorage.verifiercustomerid can be empty — this lookup makes
  // the page work without any backend/login change.
  const fetchSelfIdentity = async () => {
    try {
      const res = await axios.get(`${apiUrl}api/users/getCustomerNames`);
      let data = res.data;
      if (!Array.isArray(data)) {
        if (data && Array.isArray(data.data)) data = data.data;
        else if (data && Array.isArray(data.result)) data = data.result;
        else data = [];
      }
      const myId = String(localStorage.getItem("verifierid") || "");
      const me = data.find((c) => c && String(c._id || c.id || "") === myId);
      if (me) {
        setSelfKeys(
          [me.customerId, me.customer_id, me.name, me.customer_name].filter(Boolean)
        );
      }
    } catch (e) {
      /* customer list unavailable — the localStorage keys still apply */
    }
  };

  const filterRows = () => {
    // device.customer_id is inconsistent across legacy data — sometimes it
    // holds the partner's Mongo _id, sometimes their customerId string
    // ("WCN001"), occasionally their email or company name. Match against
    // every identity known for this login: the localStorage values saved
    // at login PLUS the customer record resolved by fetchSelfIdentity
    // (covers servers whose login payload lacks customerId). The device's
    // customer_details free-text is checked too, since partner-added
    // devices store the company name there.
    const keys = new Set(
      [
        localStorage.getItem("verifierid"),
        localStorage.getItem("verifiercustomerid"),
        localStorage.getItem("verifieremail"),
        localStorage.getItem("verifiername"),
        ...selfKeys,
      ]
        .filter(Boolean)
        .map((k) => String(k).trim().toLowerCase())
    );
    return devices.filter((device) => {
      const cid = String(device.customer_id || device.customer_uid || "")
        .trim()
        .toLowerCase();
      const cdet = String(device.customer_details || "")
        .trim()
        .toLowerCase();
      if (!keys.has(cid) && !keys.has(cdet)) return false;
      if (!searchQuery) return true;
      return Object.values(device).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      );
    });
  };

  const totalPages = Math.ceil(filterRows().length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const displayedRows = filterRows().slice(startIndex, startIndex + rowsPerPage);

  const paginationNumbers = [];
  const startPage = Math.max(1, currentPage - 4);
  const endPage = Math.min(totalPages, startPage + 7);
  for (let i = startPage; i <= endPage; i++) paginationNumbers.push(i);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedDevice((prev) => ({ ...prev, [name]: value }));
  };

  const handleNewDeviceChange = (e) => {
    const { name, value } = e.target;
    setNewDevice((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddDevice = async () => {
    try {
      const verifierId = localStorage.getItem("verifierid");
      const { customerName, ...rest } = newDevice;
      await axios.post(`${apiUrl}api/users/AddDeviceInfo`, { ...rest, customerId: verifierId || "" });
      fetchDevices();
      setNewDevice({ serial_no: "", mac_id: "", whatsapp: "", mail: "", customer_details: defaultVerifierName, contactPerson: "", VerisonDetails: "" });
      const closeBtn = document.getElementById("closeAddDeviceModal");
      if (closeBtn) closeBtn.click();
      toast.success("Device added successfully");
    } catch (error) {
      console.error("Error adding device", error);
      toast.error("Error adding device");
    }
  };

  const handleEditDevice = async () => {
    try {
      await axios.post(`${apiUrl}api/users/UpdateDeviceInfo`, selectedDevice);
      fetchDevices();
      toast.success("Device updated successfully");
    } catch (error) {
      console.error("Error updating device", error);
      toast.error("Error updating device");
    }
  };

  const modalContent = (title, fields, onSave, closeId) => (
    <div style={{ borderRadius: 12, overflow: "hidden", border: "none", boxShadow: "0 20px 60px rgba(0,0,0,0.5)", background: "#0d2628" }}>
      {/* Header */}
      <div style={{ background: "#0a1f20", padding: "16px 22px", borderBottom: "1px solid #1a3a3a", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ color: "#2eaabb", fontWeight: 700, fontSize: "15px" }}>{title}</div>
        <button type="button" id={closeId} data-dismiss="modal"
          style={{ background: "rgba(46,170,187,0.15)", border: "1px solid #1a5a62", color: "#2eaabb", width: 30, height: 30, borderRadius: "50%", fontSize: "16px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
          ×
        </button>
      </div>
      {/* Body */}
      <div style={{ padding: "20px 22px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
          {fields}
        </div>
      </div>
      {/* Footer */}
      <div style={{ padding: "14px 22px 20px", borderTop: "1px solid #1a3a3a", display: "flex", justifyContent: "flex-end", gap: 10, background: "#0a1f20" }}>
        <button type="button" data-dismiss="modal"
          style={{ padding: "8px 20px", fontSize: "13px", background: "transparent", border: "1px solid #1a5a62", borderRadius: 7, color: "#89a8c0", cursor: "pointer", fontWeight: 500 }}>
          Cancel
        </button>
        <button type="button" onClick={onSave} data-dismiss="modal"
          style={{ padding: "8px 26px", fontSize: "13px", background: "#2eaabb", border: "none", borderRadius: 7, color: "#0a1f20", fontWeight: 700, cursor: "pointer" }}>
          Save
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ background: "#06191a", minHeight: "100vh" }}>
      <Toaster position="top-right" reverseOrder={false} />
      <DeviceHistoryModal
        open={!!historyDevice}
        macId={historyDevice && historyDevice.mac_id}
        serial={historyDevice && historyDevice.serial_no}
        theme="dark"
        onClose={() => setHistoryDevice(null)}
      />
      <TopNav profileLink="verifier-profile" />

      <SideBar menus={menus} stickyLayout={true} topOffset={66} />

      <div style={{ background: "#06191a", minHeight: "100vh", paddingTop: "76px" }}>
          <div className="container-fluid">

          {/* Header bar */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 4px", marginBottom: "12px" }}>
            <h6 style={{ margin: 0, color: "#2eaabb", fontWeight: 700, fontSize: "15px", letterSpacing: "0.5px" }}>
              Device Details
              <span style={{ color: "#89a8c0", fontWeight: 400, fontSize: "13px", marginLeft: 8 }}>({filterRows().length} devices)</span>
            </h6>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <input
                type="text"
                placeholder="Search devices..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ padding: "7px 12px", width: "200px", borderRadius: "6px", border: "1px solid #1a5a62", background: "#0f2d2e", fontSize: "13px", color: "#c8dde0", outline: "none" }}
              />
              <button
                type="button"
                data-toggle="modal"
                data-target="#addDeviceModal"
                style={{ padding: "7px 16px", background: "#1a5a62", border: "1px solid #2eaabb", borderRadius: "6px", color: "#c8dde0", fontSize: "13px", cursor: "pointer", fontWeight: 600, display: "flex", alignItems: "center", gap: 6 }}
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2eaabb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
                Add Device
              </button>
            </div>
          </div>

          {/* Table */}
          <div style={{ overflowX: "auto", borderRadius: "10px", border: "1px solid #1a3a3a", background: "#0a1f20" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px", minWidth: "700px" }}>
              <thead>
                <tr style={{ background: "#0f3035" }}>
                  {[
                    { label: "SL NO",     w: "6%"  },
                    { label: "SERIAL NO", w: "20%" },
                    { label: "MAC ID",    w: "24%" },
                    { label: "WHATSAPP",  w: "16%" },
                    { label: "MAIL ID",   w: "26%" },
                    { label: "EDIT",      w: "8%"  },
                  ].map(({ label, w }) => (
                    <th key={label} style={{ width: w, padding: "10px 14px", color: "#2eaabb", fontWeight: 700, fontSize: "11px", letterSpacing: "0.7px", textTransform: "uppercase", borderBottom: "1px solid #1a3a3a", textAlign: "center", whiteSpace: "nowrap", background: "#0f3035" }}>
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {displayedRows.map((device, index) => (
                  <tr key={device._id} style={{ background: index % 2 === 0 ? "#0a1f20" : "#0d2628", borderBottom: "1px solid #132e30" }}>
                    <td style={{ padding: "10px 14px", color: "#89a8c0", textAlign: "center", verticalAlign: "middle" }}>{startIndex + index + 1}</td>
                    <td style={{ padding: "10px 14px", textAlign: "center", verticalAlign: "middle" }}>
                      {device.mac_id ? (
                        <button
                          type="button"
                          title="Previously connected patients"
                          onClick={() => setHistoryDevice(device)}
                          style={{ background: "none", border: "none", padding: 0, font: "inherit", color: "#2eaabb", fontWeight: 600, textDecoration: "underline", cursor: "pointer" }}
                        >
                          {device.serial_no || "—"}
                        </button>
                      ) : (
                        <span style={{ color: "#2eaabb", fontWeight: 600 }}>{device.serial_no || "—"}</span>
                      )}
                    </td>
                    <td style={{ padding: "10px 14px", color: "#c8dde0", textAlign: "center", verticalAlign: "middle" }}>{device.mac_id || "—"}</td>
                    <td style={{ padding: "10px 14px", color: "#c8dde0", textAlign: "center", verticalAlign: "middle" }}>{device.whatsapp || "—"}</td>
                    <td style={{ padding: "10px 14px", color: "#c8dde0", textAlign: "center", verticalAlign: "middle" }}>{device.mail || "—"}</td>
                    <td style={{ padding: "10px 14px", textAlign: "center", verticalAlign: "middle" }}>
                      <button
                        data-toggle="modal"
                        data-target="#editDeviceModal"
                        onClick={() => setSelectedDevice(device)}
                        title="Edit"
                        style={{ background: "#1a5a62", border: "1px solid #2eaabb", borderRadius: "7px", width: "32px", height: "32px", display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer", padding: 0 }}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2eaabb" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
                {displayedRows.length === 0 && (
                  <tr>
                    <td colSpan="6" style={{ padding: "30px", textAlign: "center", color: "#89a8c0", fontSize: "13px" }}>No devices found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", padding: "14px 0" }}>
            <button onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1}
              style={{ padding: "5px 16px", fontSize: "12px", borderRadius: "6px", border: "1px solid #2eaabb", background: currentPage === 1 ? "#0f3035" : "#1a5a62", color: currentPage === 1 ? "#3a6a72" : "#c8dde0", cursor: currentPage === 1 ? "not-allowed" : "pointer" }}>
              ‹ Prev
            </button>
            {paginationNumbers.map((num) => (
              <button key={num} onClick={() => setCurrentPage(num)}
                style={{ padding: "5px 10px", fontSize: "12px", borderRadius: "6px", border: "1px solid #2eaabb", background: num === currentPage ? "#2eaabb" : "#0f2d2e", color: num === currentPage ? "#0a1f20" : "#89a8c0", fontWeight: num === currentPage ? 700 : 400, cursor: "pointer" }}>
                {num}
              </button>
            ))}
            <button onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages}
              style={{ padding: "5px 16px", fontSize: "12px", borderRadius: "6px", border: "1px solid #2eaabb", background: currentPage === totalPages ? "#0f3035" : "#1a5a62", color: currentPage === totalPages ? "#3a6a72" : "#c8dde0", cursor: currentPage === totalPages ? "not-allowed" : "pointer" }}>
              Next ›
            </button>
          </div>
          </div>{/* end container-fluid */}
      </div>{/* end content */}

      {/* Edit Device Modal */}
      <div id="editDeviceModal" className="modal fade" role="dialog">
        <div className="modal-dialog" style={{ maxWidth: 560, margin: "50px auto", width: "90%" }}>
          {modalContent(
            "Edit Device Details",
            <>
              <div><label style={labelStyle}>Serial No</label><input style={inputStyle} type="text" name="serial_no" value={selectedDevice?.serial_no || ""} onChange={handleInputChange} /></div>
              <div><label style={labelStyle}>MAC ID</label><input style={inputStyle} type="text" name="mac_id" value={selectedDevice?.mac_id || ""} onChange={handleInputChange} /></div>
              <div><label style={labelStyle}>WhatsApp Number</label><input style={inputStyle} type="text" name="whatsapp" value={selectedDevice?.whatsapp || ""} onChange={handleInputChange} /></div>
              <div><label style={labelStyle}>Mail ID</label><input style={inputStyle} type="text" name="mail" value={selectedDevice?.mail || ""} onChange={handleInputChange} /></div>
              <div><label style={labelStyle}>Customer Details</label><input style={inputStyle} type="text" name="customer_details" value={selectedDevice?.customer_details || ""} onChange={handleInputChange} /></div>
              <div><label style={labelStyle}>Contact Person</label><input style={inputStyle} type="text" name="contactPerson" value={selectedDevice?.contactPerson || ""} onChange={handleInputChange} /></div>
              <div style={{ gridColumn: "1 / -1" }}><label style={labelStyle}>Version Details</label><input style={inputStyle} type="text" name="VerisonDetails" value={selectedDevice?.VerisonDetails || ""} onChange={handleInputChange} /></div>
            </>,
            handleEditDevice,
            "closeEditDeviceModal"
          )}
        </div>
      </div>

      {/* Add Device Modal */}
      <div id="addDeviceModal" className="modal fade" role="dialog">
        <div className="modal-dialog" style={{ maxWidth: 560, margin: "50px auto", width: "90%" }}>
          {modalContent(
            "Add New Device",
            <>
              <div><label style={labelStyle}>Serial Number</label><input style={inputStyle} type="text" name="serial_no" value={newDevice.serial_no} onChange={handleNewDeviceChange} /></div>
              <div><label style={labelStyle}>MAC ID</label><input style={inputStyle} type="text" name="mac_id" value={newDevice.mac_id} onChange={handleNewDeviceChange} /></div>
              <div><label style={labelStyle}>WhatsApp Number</label><input style={inputStyle} type="text" name="whatsapp" value={newDevice.whatsapp} onChange={handleNewDeviceChange} /></div>
              <div><label style={labelStyle}>Mail ID</label><input style={inputStyle} type="email" name="mail" value={newDevice.mail} onChange={handleNewDeviceChange} /></div>
              <div><label style={labelStyle}>Contact Person</label><input style={inputStyle} type="text" name="contactPerson" value={newDevice.contactPerson} onChange={handleNewDeviceChange} /></div>
              <div><label style={labelStyle}>Version Details</label><input style={inputStyle} type="text" name="VerisonDetails" value={newDevice.VerisonDetails} onChange={handleNewDeviceChange} /></div>
            </>,
            handleAddDevice,
            "closeAddDeviceModal"
          )}
        </div>
      </div>
    </div>
  );
};

export default DeviceDetailsDistributor;
